<template>
  <div class="form-request">
    <h3>Thanks for indicating interest. Please fill out this form</h3>
    <form
      action="https://docs.google.com/forms/u/1/d/e/1FAIpQLSeFVwfCR8Mvo-TfXpEQwJD1vOtugOywNn2E4OzkNQ3q0eSuZQ/formResponse"
    >
      <div class="form-control" required>
        <input
          type="text"
          name="entry.1290279987"
          placeholder="Enter your full name"
          required
        />
        <label for="entry.1290279987">Full name</label>
      </div>

      <div class="form-control" required>
        <input
          type="text"
          name="entry.1781226176"
          placeholder="Enter your phone number"
          required
        />
        <label for="entry.1781226176">Phone number</label>
      </div>

      <div class="form-control">
        <input
          type="email"
          name="entry.624321315"
          placeholder="Enter your email"
        />
        <label for="entry.624321315">Email Address</label>
      </div>

      <div class="form-control">
        <select name="entry.1055344167" required>
          <option class="default" value="">-Select an item-</option>
          <option v-for="o in optionsList" :key="o.index" :value="o">
            {{ o }}</option
          >
        </select>
        <label for="entry.1055344167">Indicate your interest</label>
      </div>

      <button class="btn btn-dark">Submit Request</button>
    </form>
  </div>
</template>

<style scoped>
.form-request {
  background-color: pink;
  padding: 2rem;
}
form div.form-control {
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 1.5rem;
}
.form-control input {
  border-radius: 1rem;
  padding: 0.5rem;
  border-style: solid;
}
.form-control select {
  background-color: whitesmoke;
  padding: 0.5rem;
  border-style: solid;
}
</style>

<script>
export default {
  props: ["optionsList"]
};
</script>
